import ngmodule from "./ngmodule";
import { IndexedDbPersistantStorage } from '../../common/persistant-storage/indexed-db-persistant-storage';
import { PromiseBasedPersistantStorage } from '../../common/persistant-storage/promise-based-persistant-storage';

ngmodule.factory(`BworkflowStorage`, [`$q`, function ($q: ng.IQService) {
	return new PromiseBasedPersistantStorage(new IndexedDbPersistantStorage(`offline-queue`, `data`, 1), $q);
}]);